// Единственное место, где определён список поддерживаемых языков.
// Новый язык: добавить код сюда, в languageLabels (App.js) и во все узлы перевода в cv.json.
export const SUPPORTED_LANGS = ['en', 'ru', 'ja'];

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

// Узел перевода — объект, все ключи которого являются кодами языков,
// например {"en": "...", "ru": "...", "ja": "..."}.
// Ограничение схемы cv.json: объекты данных не должны использовать ключи en/ru/ja.
export const isTranslationNode = (value) =>
  isPlainObject(value) &&
  Object.keys(value).length > 0 &&
  Object.keys(value).every((key) => SUPPORTED_LANGS.includes(key));

/**
 * Рекурсивно разворачивает дерево cv.json для выбранного языка:
 * узлы перевода заменяются строкой (lang → en → первый доступный),
 * остальные значения сохраняют форму.
 */
export function resolveCv(node, lang) {
  if (Array.isArray(node)) {
    return node.map((child) => resolveCv(child, lang));
  }
  if (isTranslationNode(node)) {
    if (lang in node) return node[lang];
    if ('en' in node) return node.en;
    return node[SUPPORTED_LANGS.find((code) => code in node)];
  }
  if (isPlainObject(node)) {
    const resolved = {};
    for (const [key, value] of Object.entries(node)) {
      resolved[key] = resolveCv(value, lang);
    }
    return resolved;
  }
  return node;
}
